import MarkupModel from '../MarkupModel';

export default class BundleReleaseNotesModel extends MarkupModel {

	constructor(data) {
		super(data);
	}

	setData(data) {
		super.setData(data);
		this.hasWritePermission = (!!data.hasWritePermission);
	}

	build() {
		let requestData = _.assign(super.build(), {
			version: this.version ? this.version.name : null
		});

		return requestData;
	}
}


// WEBPACK FOOTER //
// ./modules/distribution/core/models/releaseNotes/BundleReleaseNotesModel.js